
<template>
  <v-dialog v-model="dialog" scrollable  persistent max-width="500px" transition="dialog-transition" >
    <v-card style="border-radius:12px" v-if="dialog">
      <v-card-title primary-title>
        <div class="headline mb-0">Foto de perfil</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-6">
        <attach-doc btn_text='foto' :existing_doc="employee.document.document" @donePhoto="handleDonePhoto" @removePhoto="handleRemovePhoto"></attach-doc>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <f-btn @click="dialog = false" cancel></f-btn>
        <f-btn @click="submitEdit" save></f-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import Api from '@/api/index';
import AttachDoc from '@/_backoffice/_financial/components/shipping/driver/AttachDoc.vue';

export default {
  name: 'DialogEditAvatar',
  components: {
    AttachDoc,
  },
  props: {
    oneEmployee: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      dialog: false,
      employee: {}
    }
  },
  methods: {
    setupAvatar() {
      this.clearAvatar()
      let {id, document} = this.oneEmployee.data.attributes
      document = document || {}
      this.employee = {id, document, document_attributes: {} } 
    },
    clearAvatar(){
      this.employee = {}
    },
    handleDonePhoto(e) {
      this.employee.document_attributes = {...e}
    },
    handleRemovePhoto(){
      this.employee.document_attributes = {
        url_document: null,
        name: null,
        kind: null,
      }
    },
    submitEdit(){
      if (this.employee.document_attributes){

        this.swallConfirmation({
          title: 'Deseja salvar alterações?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {

            let { id } = this.employee.document
            this.employee.document_attributes = {
              id, 
              documentable_type: 'Employee',
              documentable_id: this.employee.id,
              ...this.employee.document_attributes,
            }
            
            this.updateUserWithAttachments(this.employee)
            this.dialog = false
          }
        })

        
        
      }
    },
    updateUserWithAttachments({document_attributes, id}){
      this.loading = true
      let emp = {document_attributes, id}
      Api.Employee.updateDocument(emp).then(r=> r.data).then(d => {
        this.$emit('doneAvatar', d)
      }).catch((err) => {
        
      }).finally(()=>{
        this.loading = false
      })
    },
  },
  computed: {
    is_readonly() {
      return false 
    },
    preview_avatar() {
      if (this.employee.avatar_aux){
        return this.employee.avatar_aux 
      }
    },
    ...mapState({
      //oneEmployee: state => state.Employee.oneEmployee,
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
        this.setupAvatar()
      } else if (nv == false){
        this.clearAvatar()
      }
    }
  },
}
</script>